import React from 'react';
import Tag from '$app/apps/bookings/components/Tag';

function Status({ children }) {
  if(!children) return null;
  return <Tag color={tagColour(children)}>{children}</Tag>;
}

const tagColour = val => {
  switch (val.toLowerCase()) {
    case 'draft':
      return 'grey'
    case 'active':
      return '#3be6b1'
    case 'not sent':
      return '#808080';
    case 'to review':
      return 'orange';
    case 'reviewed':
      return '#808080';
    case 'cancelled':
      return '#808080';
    case 'approved':
      return 'green';
    case 'declined':
        return 'red';
    case 'deleted':
      return 'red';
    default:
      return '#ffffff';
  }
};

export default Status;
